import React from 'react';

import { useService } from '@xstate/react';
import styled from 'styled-components'

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import {
  getColourFromColourTag,
  getColourOptions,
} from '../../../helpers/colour';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { isRollerDayNight } from '../../../helpers/isRollerDayNight';
import { productHasVariantWithMaterialType } from '../../../helpers/material';
import { productHasVariantWithMaterialTypeDayNight } from '../../../helpers/materialTypeDayNight';
import { throwError } from '../../../helpers/throwError';
import { BaseProduct, ProductBuilderMachineEvent } from '../../../types';
// import { Caption } from '../../Common/Caption';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorColour } from '../../Common/Selector';
import { SectionContent } from './SectionContent';
import { AddFreeSample } from './AddFreeSample';
// import { getBaseProduct } from '../../../helpers/getBaseProduct';
// import { getMaxHeight, getMaxWidth, getMinWidth } from '../../../helpers/metafields';
// import { getAllowedValue } from '../../../helpers/measurements';

const hexSorter = require('hexsorter');

interface Color {
  name: string;
  code: string;
  "25mm_swatch_url": string;
  "45mm_swatch_url": string;
  featured_image: string;
  colour_discount_code: string;
}

interface ColorDiscountCodes {
  [discount: string]: Color[];
}

type OnClick = (
  colourNight: string,
  send: (event: ProductBuilderMachineEvent) => void,
  products: BaseProduct[],
  discountCode?: string
) => () => void;

const onClick: OnClick = (colourNight, send, products, discountCode) => () => {
  let getColourDiscoutCode = discountCode ? null : findProduct(colourNight, products);
  let rawDiscountCode = discountCode || getColourDiscoutCode?.metafields?.colour_discount_code?.[0] || "";
  // Clean discount code - remove "%" if present and ensure it's a valid number string
  const finalDiscountCode = rawDiscountCode.toString().replace("%", "").trim();
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      colourNight,
      colourDiscoutCode: finalDiscountCode,
    },
  });
}

function findProduct(
  colour: string,
  products: BaseProduct[]
) {
  return products.find((product) => {
    return product.tags.includes(colour);
  });
}

const Caption = styled.div`
  text-align: center;
  font: 300 14px / 20px Lato;
  letter-spacing: 0.28px;
  color: rgb(38, 55, 95);
  max-width: 100%;
  margin: 7px auto 7px;
  min-height: 20px;
`;

const SaleWrapper = styled.span`
  font-size: 10px;
  color: #fff;
  background: #ff007f;
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 50%;
  transform: rotate(-40deg);
  margin-right: 2px;
`;

const DiscountLabel = styled("div")({
  "@media (min-width: 768px)": {
  },
});

// type OnMouseOver = (
//   colour: string,
//   send: (event: ProductBuilderMachineEvent) => void,
// ) => () => void;

// const onMouseOver: OnMouseOver = (colour, send) => () =>
//   send({
//     type: 'UPDATE_CUSTOM',
//     custom: {
//       colour,
//     },
//   });

export const ColourNight = () => {
  const [state, send] = useService(productBuilderMachine);

  const {
    products,
    custom: { materialType, materialTypeDay, materialTypeNight, colourNight },
  } = state.context;
  const singleMaterialTypeFilter = productHasVariantWithMaterialType(
    materialType,
  );

  const filterByMaterial = isRollerDayNight(state.context)
    ? productHasVariantWithMaterialTypeDayNight(materialTypeNight)
    : singleMaterialTypeFilter;

  const colourOptions: {
    name: string;
    code: string;
    featured_image: string;
    "25mm_swatch_url": string;
    "45mm_swatch_url": string;
    colour_discount_code: string;
  }[] = getColourOptions(products.filter(filterByMaterial));

  let colorDiscountCodes: ColorDiscountCodes = {};

  colourOptions.forEach((item) => {
    const discountCode = item.colour_discount_code;
    if (!colorDiscountCodes[discountCode]) {
      colorDiscountCodes[discountCode] = [];
    }
    colorDiscountCodes[discountCode].push({
      ...item,
    });
  });
  const sortedColorDiscountCodes = Object.entries(colorDiscountCodes)
    .sort((a, b) => {
      const discountA = parseInt(a[0].toString().replace("%", "").trim());
      const discountB = parseInt(b[0].toString().replace("%", "").trim());
      return discountB - discountA;
    })
    .reduce((obj, [key, value]) => {
      obj[key] = value;
      return obj;
    }, {} as ColorDiscountCodes);

  if (isCurrentState('colourNight', state) && colourOptions.length === 0) {
    throwError(state);
  }

  return (
    <SectionContent>  
      <Heading>Colour: Night</Heading>
      {Object.entries(sortedColorDiscountCodes).map(([discount, data]) => (
        <div
          key={discount}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            marginBlock: "10px",
          }}
        >
          {discount !== "0%" ? (
            <DiscountLabel>
              <SaleWrapper>SALE</SaleWrapper> {discount} Off
            </DiscountLabel>
          ) : null}
          <div style={{ marginTop: "10px" }} />
          <Selector
            isSlider={true}
            isColorPicker={true}
            isColorArrow={true}
            isHoneyComb={true}
          >
            {data &&
              data.map((item) => {
                const isSelected = item.name === colourNight;
                return (
                  <SelectorColour
                    isSelected={isSelected}
                    onClick={onClick(item.name, send, products, item.colour_discount_code)}
                    key={item.name}
                    colourName={item.name}
                    colourCode={item.code}
                    colourSwatch={item.featured_image}
                    colour_discount_code={item.colour_discount_code}
                  />
                );
              })}
          </Selector>
        </div>
      ))}
      {/* <Caption>{getColourFromColourTag(colourNight || '')}</Caption> */}
      {colourNight && window.location.pathname == '/collections/roller-day-night' ? <Caption>Available Maximum Size for this colour {getColourFromColourTag(colourNight || '')} <br /> (W) * (H) : 2438mm X 2438mm</Caption> : <Caption>{getColourFromColourTag(colourNight || '')}</Caption>}

      <AddFreeSample title={getColourFromColourTag(colourNight || '')} />
    </SectionContent>
  );
};
